export default "/images/fast-forward.svg?06a30349b748ce22f89e44e248bcf047";